module.exports = __webpack_public_path__ + "img/jbt9162_34_1999.prt.a3885a81.jpg";